import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getContractNoList(params) {
  if (!params.hasOwnProperty('ignoreEmptyContractNoPrice')) {
    params.ignoreEmptyContractNoPrice = false
  }
  return request({
    url: URL.mdm.getContractNoList,
    method: 'get',
    params
  })
}

// 获取船司约号对应的运价调价幅度
export function getContractNoPriceList(params) {
  return request({
    url: URL.mdm.getContractNoPriceList,
    method: 'get',
    params
  })
}

// 获取船司约号对应的加价幅度
export function getContractNoDefaultPriceList(params) {
  return request({
    url: URL.mdm.getContractNoDefaultPriceList,
    method: 'get',
    params
  })
}

// 船公司约号查询
export function queryPriceContractNo(data) {
  return request({
    url: URL.mdm.queryPriceContractNo,
    method: 'post',
    data
  })
}

// 保存船公司约号
export function saveContractNo(data) {
  return request({
    url: URL.mdm.saveContractNo,
    method: 'post',
    data
  })
}

// 更新船公司约号
export function updateContractNo(data) {
  return request({
    url: URL.mdm.updateContractNo,
    method: 'post',
    data
  })
}

// 删除船公司约号
export function deleteContractNo(data) {
  return request({
    url: URL.mdm.deleteContractNo,
    method: 'post',
    data
  })
}

// 批量保存船公司约号明细
export function batchSaveContractPrice(data) {
  return request({
    url: URL.mdm.batchSaveContractPrice,
    method: 'post',
    data
  })
}

// 根据约价查询附加费
export function querySurchargeByContractNoPrice(params) {
  return request({
    url: URL.mdm.querySurchargeByContractNoPrice,
    method: 'get',
    params
  })
}

// 保存船司约号-运价附加费整箱
export function saveContractNoPriceSurchargeFcl(surchargeFcls, contractNoPriceKeys) {
  return request({
    url: URL.mdm.saveContractNoPriceSurchargeFcl,
    method: 'post',
    data: surchargeFcls,
    params: { contractNoPriceKeys: contractNoPriceKeys.join(',') }
  })
}

